
export const CouponQueryKeys = {
  all: ["coupon"] as const,
  lists: () => [...CouponQueryKeys.all, "list"] as const,
  list: (params: object) => [...CouponQueryKeys.lists(), params] as const,
};
